import React from "react";
import { Breadcrumb } from "../../../components/Breadcrumb";

export const HandPanel = () => {
    document.title = "Əl paneli";

    const menu = [
        { name: "Ana səhifə", value: "/" },
        { name: "Kassa", value: "/cash" },
        { name: "Əl paneli", value: "/cash/handpanel", current: true },
    ];

    return (
        <div>
            <Breadcrumb menu={menu} />
            <div className="container">
                <article>
                    <h2 className="my-4">Əl paneli</h2>
                    <p>
                        Tez-tez satılan, barkodsuz məhsulların sürətli satışını təşkil etmək üçün nəzərdə tutulub. Nümunədə məhsulların kassada əl panelinə
                        əlavə olunması və əl panelindən silinməsi göstərilib.
                    </p>
                    <img src="/images/cash/handpanel.gif" alt="Əl paneli" />
                </article>
            </div>
        </div>
    );
};
